module.exports = "/_next/static/images/text-red-num-3-611f70fb.png";